import React, { Component } from 'react';
import bee from './bee-icon-png-11.png'
//import { FEED } from '../App';



class Init extends Component {
    render() {
     //   document.body.style = 'background: yellow';
        return (
            <div className='container-fluid bg-yellow w-100 h-100 text-center align-middle '>
                <h3> ApiTask </h3>
                <img className="image-option-gallery" src={bee} />
            </div>
        )
    }
}
 
export default Init;
